import React from "react";
import { observer } from "mobx-react";

const ThankYoupage = observer((store) => {
  const {
    history,
    location: { state },
  } = store;

  const navigateToLogin = () => {
    history.push("/");
  };

  return state ? (
    <div className="loginBackground">
      <div className="thank_you_wrapper">
        {state && state.status === "valid" ? (
          <p>Thank you for verifying your account!</p>
        ) : (
          <p>You have already been verified.</p>
        )}
        <button
          onClick={navigateToLogin}
          className="btn btn-common btn-profile-lg"
        >
          Log In
        </button>
      </div>
    </div>
  ) : (
    <div> Page Not Found </div>
  );
});

export default ThankYoupage;



// WEBPACK FOOTER //
// ./src/components/Thankyoupage/Thankyoupage.jsx